const shouldLog = () => !!document.querySelector("body.woocommerce-checkout");

const shippingOptionsPlugin = {
	context: {},
	tests: [
		{
			run: () => {},
			shouldLog,
			weight: 5,
			description: "Default situation",
		},
		{
			run: () => {},
			shouldLog,
			weight: 5,
			description: "Shipping options plugin active",
		},
	],
	canBeEnabled: () => {
		// return true; // Runs always
		return false;
	},
};

export default shippingOptionsPlugin;
